(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountDetailController', AppAccountDetailController);

    AppAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'AppAccount', 'Party', 'Document'];

    function AppAccountDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, AppAccount, Party, Document) {
        var vm = this;

        vm.appAccount = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:appAccountUpdate', function(event, result) {
            vm.appAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
